import { render, staticRenderFns } from "./OverflowImageSection.vue?vue&type=template&id=2c802363&scoped=true"
import script from "./OverflowImageSection.vue?vue&type=script&lang=js"
export * from "./OverflowImageSection.vue?vue&type=script&lang=js"
import style0 from "./OverflowImageSection.vue?vue&type=style&index=0&id=2c802363&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c802363",
  null
  
)

export default component.exports